export default "/images/tax.png?33d62dd19ad3bb932c0fdee7703c1c0e";